export default __webpack_public_path__ + "static/media/macbook.3a3a2f54.png";